import { configureStore, ThunkAction, Action, combineSlices } from "@reduxjs/toolkit"
import { appSlice } from "./app/appSlice"
import { setupListeners } from "@reduxjs/toolkit/query"
import { watchlistSlice } from "./watchlist/watchlistSlice"
import { hiddenCategoriesSlice } from "./hiddenCategories/hiddenCategoriesSlice"
import { seriesSlice } from "./series/seriesSlice"
import { vodSlice } from "./vod/vodSlice"
import { liveSlice } from "./live/liveSlice"

// `combineSlices` automatically combines the reducers using
// their `reducerPath`s, therefore we no longer need to call `combineReducers`.
const rootReducer = combineSlices(appSlice, watchlistSlice, hiddenCategoriesSlice, seriesSlice, vodSlice, liveSlice)
// Infer the `RootState` type from the root reducer
export type RootState = ReturnType<typeof rootReducer>

// The store setup is wrapped in `makeStore` to allow reuse
// when setting up tests that need the same store config
export const makeStore = (preloadedState?: Partial<RootState>) => {
  const store = configureStore({
    reducer: rootReducer,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    preloadedState,
  })
  // configure listeners using the provided defaults
  // optional, but required for `refetchOnFocus`/`refetchOnReconnect` behaviors
  setupListeners(store.dispatch)
  return store
}

export const store = makeStore()

// Infer the type of `store`
export type AppStore = typeof store
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore["dispatch"]

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
